





















































































































































































































































































import { Component, Vue, Provide } from "vue-property-decorator";
import { localGet, setMetaData, timeFormat } from "@/utils";
import { setCommon, errorMsg, setPage, handleResponse } from "@/utils/request";
import { pagnition } from "@/utils/commonConfig";

@Component({
  name: "PSDataModuleDashboard",
  components: {},
})
export default class CombinationProperty extends Vue {
  @Provide() private activeName: string = "idInfo";
  @Provide() private roletype: number = 1; //用户角色
  // @Provide() private psmetrics: any = {}; //数据
  @Provide() private updatetime: string = ""; //更新时间
  @Provide() private arg: any = {
    setUserid: 1039,
    Itemid: 0,
  }; //更新时间

  @Provide() private order: string = ""; //排名
  @Provide() private issearchDone: boolean = false;
  @Provide() private resultData: any = [];
  @Provide() private Userid: number | null = null;
  @Provide() private parameterData: any = []; //工单类型
  @Provide() private psmetrics: any = {
    ticketnum: "",
    assignnum: "",
    handlenum: "",
    answernum: "",
    closurenum: "",
    newoncesoldnum: "",
    newnotoncesoldnum: "",
    oldsoldnum: "",
    othersoldnum: "",
    avgticketnum: "",
    avghandletime: "",
    avganswernum: "",
    avgvolume: "",
    leftnum: "",
    time: "0s",
  };

  private created() {
    this.parameterData = [
      { id: 0, name: this.$t("ticketLgy.All") },
      { id: 103, name: "Confirm Loan" },
      { id: 104, name: "Recall" },
    ];
    this.searchStaffNum();
    let that = this;
    let timeRefrash = setInterval(function () {
      that.searchStaffNum();
    }, 5 * 60 * 1000);
  }
  //
  private changeUser(info: any) {
    if (this.roletype !== 1) {
      return;
    } else {
      let href: string =
        window.location.origin + window.location.pathname + "?userid=" + info.adminuid;
      window.open(href, "blank");
    }
  }
  //获取数据
  private async searchStaffNum() {
    this.issearchDone = true;
    this.$route.query.userid ? (this.Userid = Number(this.$route.query.userid)) : null;
    this.Userid
      ? (this.arg.setUserid = this.Userid)
      : (this.arg.setUserid = Number(localGet("userid")));


    this.getIlstData();
    const { getPSDashboardReq, getPSDashboardRequest }: any = await import(
      "@/request/phoneSaleDataModule"
    );
    let res = await getPSDashboardRequest.handleHttp(getPSDashboardReq(this.arg), this);
    if (res && res.right) {
      // this.$message.success("successfully!");
      this.roletype = res.roletype;
      if (res.leaderpsmetrics) {
        this.psmetrics = res.leaderpsmetrics;
        this.psmetrics.ticketnum = res.leaderpsmetrics.ticketnum;
        this.psmetrics.assignnum = res.leaderpsmetrics.assignnum;
        this.psmetrics.handlennum = res.leaderpsmetrics.handlenum;
        this.psmetrics.answernum = res.leaderpsmetrics.answernum;
        this.psmetrics.closurenum = res.leaderpsmetrics.closurenum;
        this.psmetrics.newoncesoldnum = res.leaderpsmetrics.newoncesoldnum;
        this.psmetrics.newnotoncesoldnum = res.leaderpsmetrics.newnotoncesoldnum;
        this.psmetrics.oldsoldnum = res.leaderpsmetrics.oldsoldnum;
        this.psmetrics.othersoldnum = res.leaderpsmetrics.othersoldnum;
      }
      if (res.psmetrics) {
        this.psmetrics = res.psmetrics;
      }
      let time: string = "";
      let hour: number = 0;
      let min: number = 0;
      if ((this.psmetrics.avghandletime * 1) / 3600 > 1) {
        hour = parseInt(`${this.psmetrics.avghandletime / 3600}`);
        if ((this.psmetrics.avghandletime % 3600) / 60 > 1) {
          min = parseInt(`${(this.psmetrics.avghandletime % 3600) / 60}`);
          time = hour + "h" + min + "min";
        } else {
          time = hour + "h" + (this.psmetrics.avghandletime % 3600) + "s";
        }
      } else {
        if ((this.psmetrics.avghandletime % 3600) / 60 > 1) {
          min = parseInt(`${(this.psmetrics.avghandletime % 3600) / 60}`);
          time = min + "min";
        } else {
          time = this.psmetrics.avghandletime + "s";
        }
      }
      // this.psmetrics.time =  this.psmetrics.AvgHandleTime%360
      this.psmetrics.time = time;
      this.updatetime = res.updatetime;
    } else {
    }
    this.issearchDone = false;
  }
  //获取列表数据
  private async getIlstData() {
    this.Userid
      ? (this.arg.setUserid = this.Userid)
      : (this.arg.setUserid = Number(localGet("userid")));
    const { getPSGroupStatsReq, getPSGroupStatsRequest }: any = await import(
      "@/request/phoneSaleDataModule"
    );
    let res = await getPSGroupStatsRequest.handleHttp(getPSGroupStatsReq(this.arg), this);
    if (res && res.right) {
      this.order = res.order;
      this.resultData = res.staffstatsList;
    } else {
    }
    this.issearchDone = false;
  }
  // private handleSizeChange(val: any) {
  //   this.pageSize = Number(val);
  //   //展示表格数据
  //   this.searchStaffNum();
  // }
  // private handleCurrentChange(val: any) {
  //   this.pageIndex = Number(val);
  //   //展示表格数据
  //   this.searchStaffNum();
  // }
  // //点击上一页
  // private handlePrevChange(val: any) {
  //   if (this.pageIndex > 0) {
  //     //展示表格数据
  //     this.searchStaffNum();
  //   }
  // }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.searchStaffNum();
  }
}
